'use client'

import React from 'react'

interface ProgressBarBlockProps {
  value?: number
  max?: number
  label?: string
  showPercentage?: boolean
  showValues?: boolean
  color?: 'primary' | 'secondary' | 'success' | 'warning' | 'danger'
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

export const ProgressBarBlock: React.FC<ProgressBarBlockProps> = ({
  value = 0,
  max = 100,
  label,
  showPercentage = true,
  showValues = false,
  color = 'primary',
  size = 'md',
  className,
}) => {
  const percentage = max === 0 ? 0 : Math.round((value / max) * 100)
  
  const colorClasses = {
    primary: 'border-primary',
    secondary: 'border-secondary',
    success: 'border-green-500',
    warning: 'border-yellow-500',
    danger: 'border-red-500',
  }

  const sizeClasses = {
    sm: 'h-6 text-xs',
    md: 'h-8 text-sm',
    lg: 'h-10 text-base',
  }

  const displayText = () => {
    if (showValues && showPercentage) {
      return `${label ? label + ': ' : ''}${value}/${max} (${percentage}%)`
    } else if (showValues) {
      return `${label ? label + ': ' : ''}${value}/${max}`
    } else if (showPercentage) {
      return `${label ? label + ': ' : ''}${percentage}%`
    } else if (label) {
      return label
    }
    return ''
  }

  return (
    <div className={`w-full ${className || ''}`}>
      <div className={`relative w-full p-1 rounded-full border-2 overflow-hidden ${colorClasses[color]} ${sizeClasses[size]}`}>
        <div
          className={`h-full bg-current rounded-l-full ${percentage < 4 ? 'rounded-r-md' : 'rounded-r-full'}`}
          style={{ 
            width: `${Math.max(2, percentage)}%`,
            color: color === 'primary' ? 'var(--color-primary)' :
                   color === 'secondary' ? 'var(--color-secondary)' :
                   color === 'success' ? 'rgb(34, 197, 94)' :
                   color === 'warning' ? 'rgb(234, 179, 8)' :
                   'rgb(239, 68, 68)'
          }}
        />
        <div className="absolute top-0 w-full h-full px-2 flex items-center justify-start font-semibold">
          {displayText()}
        </div>
      </div>
    </div>
  )
}

export default ProgressBarBlock